import { v4 as uuidv4 } from 'uuid'
import { BuildingElementType } from './Construction'

export enum BimViewMode {
  Image,
  Model3D,
}

export enum BimCategory {
  //Structural = 'Structural',
  Windows = 'WINDOWS',
  Doors = 'DOORS',
  //Roofing = 'Roofing',
  //Plumbing = 'Plumbing',
  //Hvac = 'HVAC',
}

export const BimCategoryBuildingElementTypeMapping = {
  [BimCategory.Windows]: BuildingElementType.Window,
  [BimCategory.Doors]: BuildingElementType.Door,
}

export interface BimObject {
  id: string
  manufacturer?: string
  name: string
  category: BimCategory
  subCategory: string
  height?: number
  length?: number
  thickness?: number
  thumbnailUrl?: string
  binaryUrl: string
  isNonEditable?: boolean
}
export interface BimCluster {
  category: BimCategory
  subcategories: BimGroup[]
}

export interface BimGroup {
  name: string
  objectIds: string[]
}

export const mockedBimObjects: BimObject[] = [
  {
    id: uuidv4(),
    name: 'Aluprof MB-79N SI',
    category: BimCategory.Windows,
    subCategory: 'Double-Hung',
    binaryUrl:
      '/bim/windows/double-hung/Aluprof_MB-79N-SI_E_Alu_Window-1sash-FIX-with-Vienna-Muntins.ifc',
  },
  {
    id: uuidv4(),
    name: 'Installux UNIVERS® 54',
    category: BimCategory.Windows,
    subCategory: 'Fixed',
    binaryUrl:
      '/bim/windows/fixed/Windows-Fixed-Frames-Installux-INS010009.ifc',
  },
  {
    id: uuidv4(),
    name: 'MéO 3-leaf, 2-rail sliding',
    category: BimCategory.Windows,
    subCategory: 'Sliding',
    binaryUrl:
      '/bim/windows/sliding/Baie coulissante réno 3 vantaux 2 rails MéO.ifc',
  },
  {
    id: uuidv4(),
    name: 'Installux ESPACE® O.C. 70 TH',
    category: BimCategory.Windows,
    subCategory: 'Tilt and Turn',
    binaryUrl:
      '/bim/windows/tilt-turn/Windows-Opening-Hinge-Installux-INS010007.ifc',
  },
  {
    id: uuidv4(),
    name: 'SOGAL Bloc Porte EVIDENCE',
    category: BimCategory.Doors,
    subCategory: 'Interior',
    binaryUrl: '/bim/doors/interior/Doors-Other-SOGAL-SOG040007.ifc',
  },
  {
    id: uuidv4(),
    name: 'MéO Entrance door BALADE range',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl: '/bim/doors/swing/Porte réno deux vantaux BALADE MéO.ifc',
  },
  {
    id: uuidv4(),
    name: 'GEALAN S9000 900x2000',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl:
      '/bim/doors/swing/GEALAN_S9000_Door_1-part-IFC/GEALAN_S9000_Door_900x2000-IFC4.ifc',
  },
  {
    id: uuidv4(),
    name: 'GEALAN S9000 1000x2100',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl:
      '/bim/doors/swing/GEALAN_S9000_Door_1-part-IFC/GEALAN_S9000_Door_1000x2100-IFC4.ifc',
  },
  {
    id: uuidv4(),
    name: 'GEALAN S9000 1100x1950',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl:
      '/bim/doors/swing/GEALAN_S9000_Door_1-part-IFC/GEALAN_S9000_Door_1100x1950-IFC4.ifc',
  },
  {
    id: uuidv4(),
    name: 'GEALAN S9000 1100x2000',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl:
      '/bim/doors/swing/GEALAN_S9000_Door_1-part-IFC/GEALAN_S9000_Door_1100x2000-IFC4.ifc',
  },
  {
    id: uuidv4(),
    name: 'GEALAN S9000 1200x2050',
    category: BimCategory.Doors,
    subCategory: 'Swing',
    binaryUrl:
      '/bim/doors/swing/GEALAN_S9000_Door_1-part-IFC/GEALAN_S9000_Door_1200x2050-IFC4.ifc',
  },
]
